(() => {
  'use strict';

  if (window.SkybikeTechInitialized) return;
  window.SkybikeTechInitialized = true;

  const STORAGE_KEY = 'skybike_attribution_v1';
  const ATTR_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'utm_id', 'campaign_id', 'adset_id', 'ad_id', 'placement', 'fbclid'
  ];

  const safeJsonParse = (value, fallback = {}) => {
    try { return JSON.parse(value); } catch (_) { return fallback; }
  };

  const readAttribution = () => {
    try { return safeJsonParse(localStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (_) { return {}; }
  };

  const captureAttribution = () => {
    const url = new URL(window.location.href);
    const existing = readAttribution();
    const next = { ...existing };

    ATTR_KEYS.forEach((key) => {
      const value = url.searchParams.get(key);
      if (value) next[key] = value;
    });

    if (!next.first_landing_page) next.first_landing_page = window.location.href;
    if (!next.first_referrer) next.first_referrer = document.referrer || '';
    next.last_landing_page = window.location.href;
    next.updated_at = new Date().toISOString();

    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch (_) {}
    return next;
  };

  const publish = (name, detail = {}) => {
    const payload = {
      ...detail,
      attribution: readAttribution(),
      page_path: window.location.pathname,
      timestamp: new Date().toISOString()
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `skybike_${name}`, ...payload });

    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(`skybike:${name}`, payload);
      }
    } catch (_) {}
  };

  const attributionToTags = (attr) => {
    const compact = {
      utm_source: 'sb-src',
      utm_medium: 'sb-med',
      campaign_id: 'sb-cid',
      adset_id: 'sb-asid',
      ad_id: 'sb-aid'
    };

    return Object.entries(compact)
      .map(([key, prefix]) => {
        const value = attr[key];
        if (!value) return null;
        const clean = String(value).replace(/[^a-zA-Z0-9._:-]/g, '-').slice(0, 80);
        return `${prefix}:${clean}`;
      })
      .filter(Boolean);
  };

  const hydrateLeadForms = () => {
    const attr = readAttribution();
    document.querySelectorAll('form.sbx-form-wrap, [data-skybike-lead-form]').forEach((form) => {
      const tagInput = form.querySelector('[name="contact[tags]"]');
      if (!tagInput) return;
      const baseTags = tagInput.value.split(',').map((t) => t.trim()).filter(Boolean);
      const merged = [...new Set([...baseTags, ...attributionToTags(attr)])];
      tagInput.value = merged.join(',');
    });
  };

  const initReveal = () => {
    const elements = document.querySelectorAll('.sbx-reveal');
    if (!('IntersectionObserver' in window)) {
      elements.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    elements.forEach((el) => observer.observe(el));
  };

  const initEvents = () => {
    document.addEventListener('click', (event) => {
      const target = event.target.closest('[data-skybike-event]');
      if (!target) return;
      publish(target.dataset.skybikeEvent || 'cta_click', {
        label: target.dataset.skybikeLabel || target.textContent.trim().slice(0, 100),
        href: target.getAttribute('href') || ''
      });
    });

    document.querySelectorAll('form.sbx-form-wrap, [data-skybike-lead-form]').forEach((form) => {
      form.addEventListener('submit', () => publish('lead_submit', { form_id: form.id || '' }));
    });

    document.querySelectorAll('[data-skybike-video]').forEach((video) => {
      let sent25 = false;
      let sent75 = false;
      video.addEventListener('play', () => publish('video_play', { video_id: video.dataset.skybikeVideo || '' }), { once: true });
      video.addEventListener('timeupdate', () => {
        if (!video.duration) return;
        const p = video.currentTime / video.duration;
        if (p >= .25 && !sent25) { sent25 = true; publish('video_25', { video_id: video.dataset.skybikeVideo || '' }); }
        if (p >= .75 && !sent75) { sent75 = true; publish('video_75', { video_id: video.dataset.skybikeVideo || '' }); }
      });
    });
  };

  const initCountdowns = () => {
    document.querySelectorAll('[data-skybike-countdown]').forEach((node) => {
      const target = node.dataset.skybikeCountdown;
      if (!target) return;
      const targetMs = Date.parse(target);
      if (Number.isNaN(targetMs)) return;

      const tick = () => {
        const diff = targetMs - Date.now();
        if (diff <= 0) { node.textContent = 'LIVE NOW'; return; }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        node.textContent = `${d}d ${String(h).padStart(2, '0')}h ${String(m).padStart(2, '0')}m`;
      };
      tick();
      window.setInterval(tick, 60000);
    });
  };

  captureAttribution();
  document.addEventListener('DOMContentLoaded', () => {
    hydrateLeadForms();
    initReveal();
    initEvents();
    initCountdowns();
  });

  window.SkybikeAttribution = { get: readAttribution, capture: captureAttribution };
  window.SkybikeTrack = publish;
})();
